module.exports = __webpack_public_path__ + "static/media/fair.09c71ec6.png";